import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { collection, doc, updateDoc } from "firebase/firestore";
import { DragDropContext } from "react-beautiful-dnd";
import { updateProjectLastModified } from "@comp/project-last-modified/actions";
import { createContext, useContext, useReducer } from "react";
import { listifyObject } from "@root/utils";
import { getFirebaseTimestamp, projects } from "@config/firestore";
import { addIndex, append, ascend, assoc, assocPath, equals, filter, map, move, path, pathOr, prop, propEq, reduce, sort } from "ramda";
import { jsx as ___EmotionJSX } from "@emotion/react";
var initialState = {
    docIdx: {}
};
export var DnDStateContext = /*#__PURE__*/ createContext(initialState);
export var DnDDispatchContext = /*#__PURE__*/ createContext(
// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
function (dispatch) { });
var reduceIndexed = addIndex(reduce);
var reducer = function reducer(state, action) {
    switch (action.type) {
        case "handleDrop":
            {
                if (action.payload.reason === "DROP" && action.payload.destination) {
                    var destinationUid = action.payload.destination.droppableId;
                    var sourceUid = action.payload.source.droppableId;
                    var destinationDocument = action.project.documents[destinationUid];
                    var sourceDocument = action.project.documents[sourceUid];
                    if (destinationDocument.type === "folder") {
                        updateDoc(doc(collection(doc(projects, action.project.projectUid), "files"), sourceUid), {
                            path: append(destinationUid, destinationDocument.path || []),
                            lastModified: getFirebaseTimestamp()
                        });
                        updateProjectLastModified(action.project.projectUid);
                    }
                    else if (!equals(destinationDocument.path, sourceDocument.path)) {
                        updateDoc(doc(collection(doc(projects, action.project.projectUid), "files"), sourceUid), {
                            path: destinationDocument.path || [],
                            lastModified: getFirebaseTimestamp()
                        });
                        updateProjectLastModified(action.project.projectUid);
                    }
                }
                return state;
            }
        // WIP
        case "reorder":
            {
                // const docUid = pathOr(null, ["payload", "draggableId"], action);
                var sourceIndex = pathOr(0, ["payload", "source", "index"], action);
                var destinationId = pathOr("", ["payload", "destination", "droppableId"], action);
                var destinationIndex = pathOr(0, ["payload", "destination", "index"], action);
                var destinationDirectoryFiles = filter(propEq("parent", destinationId), state.docIdx);
                var sortableList = map(function (x) {
                    return {
                        index: path(["val", "index"], x),
                        uid: prop("key", x)
                    };
                }, listifyObject(destinationDirectoryFiles));
                var filesToReorder = sort(ascend(prop("index")), sortableList);
                var reorderedFiles = move(sourceIndex, destinationIndex, filesToReorder);
                var newState = reduceIndexed(function (accumulator, item, newIndex) {
                    return assocPath(["docIdx", item.uid, "index"], newIndex, accumulator);
                }, state, reorderedFiles);
                return newState;
            }
        case "setDocIdx":
            {
                return assoc("docIdx", action.docIdx, state);
            }
        default:
            {
                return state;
            }
    }
};
export var DnDProvider = function DnDProvider(_ref) {
    var children = _ref.children, project = _ref.project;
    var _useReducer = useReducer(reducer, initialState), _useReducer2 = _slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    return ___EmotionJSX(DragDropContext, {
        onDragEnd: function onDragEnd(result) {
            return dispatch({
                type: "handleDrop",
                payload: result,
                project: project
            });
        }
    }, ___EmotionJSX(DnDStateContext.Provider, {
        value: state
    }, ___EmotionJSX(DnDDispatchContext.Provider, {
        value: dispatch
    }, children)));
};
export var useDnDState = function useDnDState() {
    var context = useContext(DnDStateContext);
    if (context === undefined) {
        throw new Error("useDnDState must be used within a DnDProvider");
    }
    return context;
};
export var useDnDDispatch = function useDnDDispatch() {
    var context = useContext(DnDDispatchContext);
    if (context === undefined) {
        throw new Error("useDnD must be used within a DnDProvider");
    }
    return context;
};
export var useDnD = function useDnD() {
    return [useDnDState(), useDnDDispatch()];
};
